import React, { useState } from 'react';
import { useTranslation } from "react-i18next";

const InvisibleCharacterGenerator = () => {
  const [invisibleChar, setInvisibleChar] = useState('');
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  // Function to generate invisible character
  const generateInvisibleChar = () => {
    const zeroWidthSpace = '\u200B'; // Zero-width space character
    setInvisibleChar(zeroWidthSpace);
    setCopied(false);
  };

  // Function to copy invisible character to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(invisibleChar)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset copied status after 2 seconds
      })
      .catch(err => console.error('Failed to copy: ', err));
  };

  return (
    <div className='main-tool'>
      <div class="button-wrapper">
        <button className='tool-gnt' onClick={generateInvisibleChar}> {t("generate_blank_text")}</button>

      </div>
      {invisibleChar && (
        <div class="button-wrapper">
          <button className='tool-gnt' onClick={copyToClipboard}> {t("copy_to_clipboard")}</button>
          {copied && <span className='spn-txt'>{t("copied")}</span>}
        </div>
      )}
    </div>
  );
};

export default InvisibleCharacterGenerator;
